// @flow

import config, {defaultConfig} from './config';

const getConfig = (name: string): FacetConfig => config[name] ?? {};

const withFacetConfig = (facet: Facet): FacetWithConfig => ({
  ...facet,
  ...defaultConfig,
  ...getConfig(facet.name ?? facet.searchFacetId),
});

export default withFacetConfig;
